/* eslint-disable react-hooks/exhaustive-deps */
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import notificationState from "../../states/notificationState";
import getSchema from "../../lib/api/getSchema";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import AccessControl from "../functional/AccessControl";
import { useTranslation } from "react-i18next";
import EguOutSourcingPurchaseDetailCreateButton from "../input/EguOutSourcingPurchaseDetailCreateButton";
import EguOutSourcingPurchaseDetailUpdateButton from "../input/EguOutSourcingPurchaseDetailUpdateButton";
import DeleteRecordButton from "../input/DeleteRecordButton";
import SaveToExcelButton from "../input/SaveToExcelButton";
import { cloneDeep } from "lodash";
import defineConf from "../../config/defineConf";

function EguOutSourcingPurchaseDetail(props) {
    const { onSelectMst, onDetailEmpty } = props;

    const id = "EguOutSourcingPurchaseDetail";
    const table = "EguOutSourcingPurchaseDetail";
    const view = "EguVwOutSourcingPurchaseDetail";

    const { t } = useTranslation();

    const [eguOutSourcingPurchaseDetailSchema, setEguOutSourcingPurchaseDetailSchema] = useState();
    const [eguOutSourcingPurchaseDetailGrid, setEguOutSourcingPurchaseDetailGrid] = useState();
    const [eguOutSourcingPurchaseDetailApi, setEguOutSourcingPurchaseDetailApi] = useState();
    const [eguOutSourcingPurchaseDetailDataIsEmpty, setEguOutSourcingPurchaseDetailDataIsEmpty] = useState();

    const [, setNotification] = useRecoilState(notificationState);

    useEffect(() => {
        let mounted = true;

        (async () => {
            let schema = await getSchema(table);

            if (mounted) {
                setEguOutSourcingPurchaseDetailSchema(schema);
            }
        })();

        return () => {
            mounted = false;
        };
    }, []);

    useEffect(() => {
        if (eguOutSourcingPurchaseDetailApi) {
            eguOutSourcingPurchaseDetailApi.refresh();
        }
    }, [onSelectMst.outSourcingId]);

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const notifyWarning = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);

        if (eguOutSourcingPurchaseDetailApi) {
            eguOutSourcingPurchaseDetailApi.refresh();
        }
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };

    const onPartialFailure = (msg) => {
        notifyWarning(msg);

        if (eguOutSourcingPurchaseDetailApi) {
            eguOutSourcingPurchaseDetailApi.refresh();
        }
    };

    const onDialogUpdateDetail = () => {
        if (eguOutSourcingPurchaseDetailApi) {
            eguOutSourcingPurchaseDetailApi.refresh();
        }
    };

    const doHandleBackendErrorMsg = (reason) => {
        // reason.response := { data, status, statusText, headers, config, request }
        // data : user error message
        // status : http status code
        // statusText : http status code text
        const response = reason.response;
        return `${response.data} `;
    };

    const onChangeInOutType = (schema, inOutType) => {
        let clonedSchema = cloneDeep(schema);

        clonedSchema.columns.map((column) => {
            if (column.name === "outSourcingMaterialQty") {
                if (inOutType === "OUT") {
                    return (column["disabled"] = true);
                } else {
                    return (column["disabled"] = false);
                }
            }

            return column;
        });

        return clonedSchema;
    };

    return (
        <BasicCrudScreenType
            id={id}
            headerTitle={t("term.eguOutSourcingPurchaseDetail")}
            table={table}
            view={view}
            onModifyViewUrl={(url) => `${url}/${onSelectMst.outSourcingId}`}
            onInitialized={(grid) => {
                setEguOutSourcingPurchaseDetailGrid(grid);
            }}
            onApiInitialized={(api) => {
                setEguOutSourcingPurchaseDetailApi(api);
            }}
            onLoadData={(data) => {
                const isEmpty = data.length < 1 ? true : false;

                setEguOutSourcingPurchaseDetailDataIsEmpty(isEmpty);

                if (onDetailEmpty) {
                    onDetailEmpty(isEmpty);
                }
            }}
            onAppendButtonInFrontOfSearch={() => (
                <BasicCrudScreenActionItemLayout>
                    <AccessControl
                        accessTarget={eguOutSourcingPurchaseDetailSchema && eguOutSourcingPurchaseDetailSchema.name}
                        accessMethod="POST"
                    >
                        <EguOutSourcingPurchaseDetailCreateButton
                            id={id}
                            schema={eguOutSourcingPurchaseDetailSchema}
                            refresh={eguOutSourcingPurchaseDetailApi}
                            disabled={
                                onSelectMst?.length <= 0 ? true : false ||
                                onSelectMst?.approvalState ||
                                onSelectMst?.outSourcingStatus >= defineConf.outSourcingStatus.SHIP_COMPLETE
                            }
                            onSuccess={onSuccess}
                            onSelectMst={onSelectMst}
                            customizeErrorMsgCallback={doHandleBackendErrorMsg}
                            onDialogUpdateDetail={onDialogUpdateDetail}
                            onChangeInOutType={onChangeInOutType}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={eguOutSourcingPurchaseDetailSchema && eguOutSourcingPurchaseDetailSchema.name}
                        accessMethod={
                            eguOutSourcingPurchaseDetailSchema &&
                            (eguOutSourcingPurchaseDetailSchema.updateWithPatch ? "PATCH" : "PUT")
                        }
                    >
                        <EguOutSourcingPurchaseDetailUpdateButton
                            id={id}
                            schema={eguOutSourcingPurchaseDetailSchema}
                            grid={eguOutSourcingPurchaseDetailGrid}
                            refresh={eguOutSourcingPurchaseDetailApi}
                            disabled={
                                onSelectMst?.approvalState ||
                                onSelectMst?.outSourcingStatus >= defineConf.outSourcingStatus.SHIP_COMPLETE ||
                                eguOutSourcingPurchaseDetailDataIsEmpty
                            }
                            onSuccess={onSuccess}
                            onChangeInOutType={onChangeInOutType}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={eguOutSourcingPurchaseDetailSchema && eguOutSourcingPurchaseDetailSchema.name}
                        accessMethod="DELETE"
                    >
                        <DeleteRecordButton
                            id={id}
                            schema={eguOutSourcingPurchaseDetailSchema}
                            grid={eguOutSourcingPurchaseDetailGrid}
                            refresh={eguOutSourcingPurchaseDetailApi}
                            color="secondary"
                            disabled={
                                onSelectMst?.approvalState ||
                                onSelectMst?.outSourcingStatus >= defineConf.outSourcingStatus.SHIP_COMPLETE ||
                                eguOutSourcingPurchaseDetailDataIsEmpty
                            }
                            onSuccess={onSuccess}
                            onFailure={onFailure}
                            onPartialFailure={onPartialFailure}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={eguOutSourcingPurchaseDetailSchema && eguOutSourcingPurchaseDetailSchema.name}
                        accessMethod="SAVETOEXCEL"
                    >
                        <SaveToExcelButton
                            id={id}
                            grid={eguOutSourcingPurchaseDetailGrid}
                            view={view}
                            color="primary"
                            exportFormatItem={() => {}}
                            disabled={eguOutSourcingPurchaseDetailDataIsEmpty}
                        />
                    </AccessControl>
                </BasicCrudScreenActionItemLayout>
            )}
            noCreate
            noEdit
            noDelete
            noExcel
        />
    );
}

export default EguOutSourcingPurchaseDetail;
